import React from 'react';
import {isMobile} from 'react-device-detect';
import PropTypes from 'prop-types';
import {useLocation} from 'react-router-dom';
import {SidebarMenuButton} from './styles';

const ClosableSidebarButton = ({
  //  isActive,
  closeSidebar,
  activeClassName,
  to,
  children,
  dataPhClick,
  dataLabel,
  dataRoute,
  onClick
}) => {
  const location = useLocation();

  // If the user is already on a sub-route of `to` (e.g. on /orders/123 with to=/orders),
  // keep them there instead of redirecting to `to` and losing their current page.
  // The trailing `/` is required to ensure a path boundary — without it, /marketing would
  // wrongly match /marketing-integrations.
  const isOnSubRoute = location.pathname.startsWith(`${to}/`);
  const targetRoute = isOnSubRoute ? location.pathname : to;

  const handleClick = () => {
    if (onClick) onClick();
    if (isMobile) {
      closeSidebar();
    }
  };

  return (
    <SidebarMenuButton
      //      isActive={isActive}
      activeClassName={activeClassName}
      to={targetRoute}
      onClick={handleClick}
      data-ph-click={dataPhClick}
      data-label={dataLabel}
      data-route={dataRoute}
    >
      {children}
    </SidebarMenuButton>
  );
};

ClosableSidebarButton.propTypes = {
  //  isActive: PropTypes.func,
  closeSidebar: PropTypes.func.isRequired,
  activeClassName: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  dataPhClick: PropTypes.string.isRequired,
  dataLabel: PropTypes.string.isRequired,
  dataRoute: PropTypes.string.isRequired,
  onClick: PropTypes.func
};

ClosableSidebarButton.defaultProps = {
  onClick: undefined
};

export default ClosableSidebarButton;
